var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.814 4.999l-.001-.261c0-1.084.063-2.071.159-2.715l.083-.401c.047-.212.108-.454.172-.577.233-.45.69-.73 1.179-.73h.042c.628.021 1.366.458 1.912.769 1.09.62 2.462 1.583 3.19 2.322l.28.292c.072.08.154.173.205.246.17.225.255.504.255.783 0 .312-.095.601-.275.838l-.287.31-.064.066c-.87.945-3.144 2.49-4.334 2.963l-.18.069c-.215.077-.518.17-.702.178a1.47 1.47 0 01-.669-.161 1.388 1.388 0 01-.595-.666c-.193-.501-.246-1.05-.294-1.584-.044-.502-.07-1.1-.076-1.741zM.049 4.733c0-.617.495-1.118 1.106-1.118l2.721.241c.48 0 .868.393.868.877a.872.872 0 01-.868.877l-2.721.24c-.61 0-1.106-.5-1.106-1.117z",
    fill: "#200E32",
    fillOpacity: 0.75
  })));
}

export default __webpack_public_path__ + "43bb4719514b0543eb4d80b9f548ca6a.svg";
export { SvgNext as ReactComponent };